import { FC } from "react";
import cx from "classnames";
import "styles/modal.scss";
import { useDispatch, useSelector } from "react-redux";
import { setIsModalShow } from "store/slice/search.slice";
import { ModalType } from "types/atoms.types";
import type { RootState } from "store";
import * as Icons from 'constants/icons';

const Modal: FC<ModalType> = ({ children }) => {
  const searchState = useSelector((state: RootState) => state.search)
  const dispatch = useDispatch();
  const isActiveClass = cx("asr_modal", { active: searchState?.isModalShow });
  const handleOnCloseModal = () => {
    dispatch(setIsModalShow(false));
  };
  return (
    <div className={isActiveClass}>
      <div className="asr_modal_content">
        <img
          className="asr_close_btn"
          src={Icons.cross}
          alt="Close"
          onClick={handleOnCloseModal}
        />
        {children}
      </div>
    </div>
  );
};

export default Modal;
